import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page99() {
  useEffect(() => {
    document.title = "Маяк — Страница 98"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page97" />
        <ForwardLink href="/" />
      </div>

      <p style={{ textAlign: "right" }}>98.</p>
      <p>СНАРУЖИ. КАМЕННЫЙ ОСТРОВ – РАССВЕТ</p>
      <p>МОЛОДОЙ лежит обнаженный, распростертый на камнях, кости сломаны.</p>
      <p>
        Он слеп. Его глаза — кровавые, выжженные глазницы. Он не может<br/>
        двигаться. Водоросли обвивают его.
      </p>
      <p>Морская птица клюет его в живот...</p>
      <p>Клюет. Клюет. Клюет.</p>
      <p>Это ОДНОГЛАЗАЯ ЧАЙКА...</p>
      <p>Она тянет печень МОЛОДОГО...</p>
      <p>МОЛОДОЙ стонет...</p>
      <p>Десятки и десятки ПТИЦ слетаются к МОЛОДОМУ, раздирая его.</p>
      <p>Пожирают его.</p>
      <p>
        КАМЕРА отъезжает, показывая его одного на КАМЕННОМ ОСТРОВЕ. (КАМЕРА<br/>
        не отъезжает так далеко, чтобы увидеть маяк или<br/>
        хозяйственные постройки.)
      </p>
      <p>Только МОЛОДОЙ и стая морских птиц, пожирающих его.</p>
      <p>ЗАДЕРЖКА.</p>
      <p>КОНЕЦ.</p>
      <p style={{ textAlign: "right" }}>98.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page97" />
        <ForwardLink href="/" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710719477/the-lighthouse-script/krsp4bxtqtrtfpedkrof.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page99;
